import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Tooltip } from "@mui/material";
export var TeamAvatar = function (_a) {
    var _b;
    var team = _a.team;
    return (_jsx(Tooltip, { title: team.name, arrow: true, children: _jsx(Avatar, { alt: team.name, src: team.logo || undefined, sx: { width: 56, height: 56 }, children: (_b = team.name.match(/\b(\w)/g)) === null || _b === void 0 ? void 0 : _b.join("") }) }));
};
